import React, { useState, useEffect } from "react";
import axios from "axios";

function Discount() {
  const [entries, setEntries] = useState([]);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "https://onlineexam.ssccglpinnacle.com/api/product-discounts"
        );
        if (res.data?.data) {
          setEntries(res.data.data);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setMessage("Failed to load data");
      }
    };
    fetchData();
  }, []);

  return (
    <div
      style={{
        maxWidth: "720px",
        margin: "0 auto",
        padding: "24px 16px",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          fontWeight: 700,
          fontSize: "24px",
          margin: "8px 0 24px",
          color: "#333",
        }}
      >
        Commission Discount
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "12px",
          fontWeight: 600,
          fontSize: "16px",
          color: "#333",
          textAlign: "center",
          background: "#f9f9f9",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          padding: "12px 8px",
          marginBottom: "16px",
        }}
      >
        <div>Product Category</div>
        <div>Commission (%)</div>
      </div>

      <div
        style={{
          display: "grid",
          gap: "12px",
        }}
      >
        {entries.map((entry, index) => (
          <div
            key={index}
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "15px",
              alignItems: "center",
              background: "#fff",
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #eef2f7",
              boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
            }}
          >
            <div
              style={{
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                textAlign: "center",
                backgroundColor: "#f5f5f5",
                color: "#374151",
                fontWeight: 500,
              }}
            >
              {entry.category}
            </div>
            <div
              style={{
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                textAlign: "center",
                backgroundColor: "#f9fafb",
                color: "#111827",
                fontWeight: 600,
              }}
            >
              {entry.minDiscount}
            </div>
          </div>
        ))}
      </div>

      {message && (
        <div
          style={{
            marginTop: "12px",
            textAlign: "center",
            fontSize: "14px",
            color: "#ef4444",
          }}
        >
          {message}
        </div>
      )}
    </div>
  );
}

export default Discount;
